export default __webpack_public_path__ + "static/media/449.afd76690.gif";